import { kebabCase } from '@fergdigitalcommerce/fergy-utilities';
import { type CarouselItemFieldsFragment } from '../../../../../__generated__/graphql-client-types';
import { NO_IMAGE_URL } from '../../../../../constants/images';
import { type CarouselContent, type ContentComponent } from '../../../../../types/construct.types';
import { HomeCarousel } from '../../../../home-components/home-carousel/home-carousel.component';

export const CarouselHandler: ContentComponent<CarouselContent> = ({
	content: {
		fields: { title, carousel }
	}
}) => {
	// TODO: EFDC-36937 - HomeCarousel is tightly coupled to GraphQL fragment types. Once the migration is complete,
	// refactor HomeCarousel to consume construct types directly and remove the fragment dependencies.
	const items: CarouselItemFieldsFragment[] = carousel.items.map((item) => ({
		__typename: 'HomePageCarouselItem' as const,
		title: item.fields.title ?? '',
		image: {
			id: item.fields.image.image?.id ?? NO_IMAGE_URL,
			imageType: item.fields.image.image?.imageType ?? 'private',
			description: item.fields.image.image?.description ?? '',
			lowQualityPlaceholder: item.fields.image.image?.lowQualityPlaceholder ?? ''
		},
		trackingLink: {
			name: 'Link',
			url: item.fields.link.linkUrl,
			tracking: item.fields.link.trackingCode ?? ''
		}
	}));
	return <HomeCarousel items={items} title={title} automationHook={`${kebabCase(title || '')}-swipe`} />;
};
